import { Bloc, ErrorState, InitEvent, ProcessingState } from '../base-bloc';
import { Injectable } from '@angular/core';
import { AuthenticationRepository } from '../../../core/data/repository/authentication-repository';
import {
  AppBlocEvent,
  AppBlocState,
  AuthenticatedUserDataReadyState,
  ChangeUserPhotoEvent,
  ChangeUserPhotoState,
  LoggedOutState,
  LogoutEvent,
  InitApplicationTheme,
  UpdateAplicationTheme,
  UpdateThemeReadyState,
  ThemeReadyState
} from './';
import { NonDrawing } from '../../model';
import { takeUntil } from 'rxjs';
import { ThemesService } from '../../../core/services/themes.service';

@Injectable({
  providedIn: 'root',
})
export class AppBloc extends Bloc<AppBlocEvent, AppBlocState> {
  constructor(private authenticationRepository: AuthenticationRepository, private themesService: ThemesService) {
    super();
  }
  onIncomingEvents(event: AppBlocEvent): void {
    if (event instanceof ChangeUserPhotoEvent) {
      this.onState$.next(new ChangeUserPhotoState(event.userImageUrl));
    } else if (event instanceof InitEvent) {
      this.onState$.next(new AuthenticatedUserDataReadyState(this.authenticationRepository.currentUser$.value));
    } else if (event instanceof LogoutEvent) {
      // fake loading
      this.onState$.next(new ProcessingState<NonDrawing>(new NonDrawing()));
      // call repository
      this.authenticationRepository
        .logout()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            this.onState$.next(new LoggedOutState());
            this.onState$.next(undefined);
          },
          error: (error) => {
            new ErrorState<NonDrawing>(new NonDrawing(), error);
          },
        });
    } else if(event instanceof InitApplicationTheme) {
      //fake loading
      this.onState$.next(new ProcessingState<NonDrawing>(new NonDrawing()));
      // update application theme
      this.onState$.next(new ThemeReadyState(this.themesService.currentTheme));
    } else if (event instanceof UpdateAplicationTheme) {
      //fake loading
      this.onState$.next(new ProcessingState<NonDrawing>(new NonDrawing()));
      // update application theme
      this.onState$.next(new UpdateThemeReadyState(event.theme));
    }
  }
}
